import instance from "./api";

const REQUEST_PATHS = {
  ORDER: '/orders/details-v2',
  ORDER_DETAILS: '/orders/delivery-details'
};

/**
 * Generates headers for API requests based on the business ID.
 *
 * @param {string} businessId - The ID of the business.
 * @returns {object} - Headers object.
 */
const getHeaders = (businessId) => ({
  'Content-Type': 'application/json',
  'business': businessId
});

/**
 * Constructs the full URL for the ORDER endpoint.
 *
 * @param {string} businessId - The ID of the business.
 * @param {string} orderId - The ID of the order.
 * @returns {string} - Full URL for the ORDER endpoint.
 */
const constructOrderUrl = (orderId, businessUuid) =>
  `${REQUEST_PATHS.ORDER}/${businessUuid}/${orderId}`;

/**
 * Constructs the full URL for the ORDER_DETAILS endpoint.
 *
 * @param {string} orderId - The ID of the order.
 * @returns {string} - Full URL for the ORDER_DETAILS endpoint.
 */
const constructOrderDetailsUrl = (orderId) =>
  `${REQUEST_PATHS.ORDER_DETAILS}/${orderId}`;

/**
 * Fetches order details by order ID and business ID.
 *
 * @param {string} orderId - The ID of the order.
 * @param {string} businessId - The ID of the business.
 * @returns {Promise} - Axios promise for the GET request.
 */
export const getOrderById = (orderId, businessId, businessUuid) =>
  instance.get(constructOrderUrl(orderId, businessUuid), { headers: getHeaders(businessId) });

/**
 * Fetches delivery details of an order by order ID and business ID.
 *
 * @param {string} orderId - The ID of the order.
 * @param {string} businessId - The ID of the business.
 * @returns {Promise} - Axios promise for the GET request.
 */
export const getOrderDetailsById = (orderId, businessId) =>
  instance.get(constructOrderDetailsUrl(orderId), { headers: getHeaders(businessId) });
